module.exports = __webpack_public_path__ + "static/blog-img3-a6e928342717be5ef58e799dc82decfd.png";